import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=1c74a613&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c74a613')) {
      api.createRecord('1c74a613', component.options)
    } else {
      api.reload('1c74a613', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=1c74a613&", function () {
      api.rerender('1c74a613', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/components/Footer.vue"
export default component.exports